import { clsx } from 'clsx';
import { VerticalStack } from '@interxfi/design-system/components/alignment/vertical-stack';
import { Typography } from '@interxfi/design-system/components/typography';
import { useLayoutContext } from '../../context';
import { SidebarNavItem, type SidebarNavItemGroup } from '../nav-item/sidebar-nav-item';
import styles from './sidebar-nav-group.module.scss';

export function SidebarNavGroup({ id, items, label }: SidebarNavItemGroup) {
  const { collapsedSidebarStatus, isMobile } = useLayoutContext();
  return (
    <VerticalStack as="ul" className={styles.navGroup} gap={1}>
      {label ? (
        <Typography.Level3 className={clsx(styles.label, !isMobile && styles[`state-${collapsedSidebarStatus}`])} lineHeight="1rem" tone="neutral-dk">
          {label}
        </Typography.Level3>
      ) : null}
      {items.map((item) => (
        <SidebarNavItem {...item} key={item.id} layoutGroupId={id} level={0} />
      ))}
    </VerticalStack>
  );
}
